import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "workspace-title text-subtitle-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_markdown_excerpt = _resolveComponent("ontos-markdown-excerpt")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["workspace-row", {'workspace-row--closed': _ctx.system.closed}])
  }, [
    _createVNode(_component_router_link, {
      class: "workspace-text",
      to: {name: 'view-system', params: {system: _ctx.system.alias}}
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.system.title), 1),
        (_ctx.description)
          ? (_openBlock(), _createBlock(_component_ontos_markdown_excerpt, {
              key: 0,
              value: _ctx.description,
              class: "workspace-description text-body-2 text-medium-emphasis"
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (_ctx.collectionNames)
          ? (_openBlock(), _createElementBlock("span", {
              key: _ctx.collectionNames,
              class: "workspace-collections text-body-2 text-medium-emphasis ontos-arrives"
            }, _toDisplayString(_ctx.collectionNames), 1))
          : _createCommentVNode("", true),
        (_ctx.numbers)
          ? (_openBlock(), _createElementBlock("span", {
              key: _ctx.numbers,
              class: "workspace-numbers text-caption text-medium-emphasis ontos-arrives"
            }, _toDisplayString(_ctx.numbers), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["to"]),
    (_ctx.system.accessLevel)
      ? (_openBlock(), _createBlock(_component_ontos_colored_value, {
          key: 0,
          option: _ctx.levelOption(_ctx.system.accessLevel),
          form: "chip",
          class: "workspace-level"
        }, null, 8, ["option"]))
      : _createCommentVNode("", true),
    (_ctx.designs)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          icon: "mdi-tune",
          variant: "text",
          size: "small",
          class: "workspace-design",
          title: _ctx.$tt('design-of', {name: _ctx.system.title}),
          "aria-label": _ctx.$tt('design-of', {name: _ctx.system.title}),
          to: {name: 'design-system', params: {system: _ctx.system.alias}}
        }, null, 8, ["title", "aria-label", "to"]))
      : _createCommentVNode("", true)
  ], 2))
}